import React from 'react';
import { Modal } from '@hover/blueprint';
import DownloadAppModalMobile from './DownloadAppModalMobile';
import DownloadAppModalContentDesktop from './DownloadAppModalContentDesktop';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const DownloadAppModal: React.FC<Props> = ({ isOpen, onClose }) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    isCentered
    size="xl"
    maxContentHeight="100vh"
    w="100vw"
  >
    <DownloadAppModalContentDesktop />
    <DownloadAppModalMobile />
  </Modal>
);

export default DownloadAppModal;
